export default __webpack_public_path__ + "static/media/journeys.c9b39af8.svg";